<template>
  <router-link
    :to="{
      name: 'capsule',
      params: { name: capsule.title, projectId: capsule._id }
    }"
  >
    <div class="card">
      <div class="card-image">
        <figure class="image is-5by3">
          <img
            :src="capsule.mainImage[0].fileUrl"
            alt="Placeholder image"
            v-if="capsule.mainImage"
          />
        </figure>
        <div class="field is-overlay" v-if="capsule.topic">
          <div class="control">
            <span class="tag is-dark has-text-weight-bold is-size-7">{{
              capsule.topic
            }}</span>
          </div>
        </div>
      </div>
      <div class="card-content">
        <div class="media">
          <div class="media-content">
            <p class="title is-5">{{ capsule.title }}</p>
            <p class="subtitle is-6 has-text-grey">{{ capsule.courses }}</p>
            <i18n path="Capsule.partner_path" tag="span" class="is-size-6">
              <span class="has-text-grey">{{
                $t("Capsule.supported_by")
              }}</span>
              <a
                class="is-6 is-link"
                :href="capsulePartner['partner-url']"
                @click.stop
                target="_blank"
              >
                {{ capsulePartner.title }}
              </a>
            </i18n>
          </div>
        </div>
        <div class="content"></div>
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  props: {
    capsule: { default: {} }
  },
  computed: {
    capsulePartner () {
      return this.$store.getters.capsulePartner(this.capsule._id)
    }
  }
}
</script>

<style scoped>
img {
  object-fit: cover;
}
.title {
  margin-top: 0 !important;
}
.subtitle {
  margin-bottom: 0 !important;
}
.field {
  margin: 1rem;
}
.card-image .image {
  height: 190px;
}
</style>
